import React from "react";

const ContentRecommendationsSkeleton: React.FC = () => (
  <div className="space-y-2 animate-pulse">
    {/* Horários Ótimos */}
    <div className="bg-white rounded-xl border border-purple-200 p-3 shadow-xs">
      <div className="flex items-start justify-between border-b pb-2 border-purple-100 mb-3">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-purple-200 rounded-xl shrink-0" />
          <div className="h-10 flex flex-col justify-between">
            <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
            <div className="h-2.5 w-56 bg-gray-200 rounded-sm" />
          </div>
        </div>
        <div className="h-8 w-20 bg-gray-100 rounded-lg" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="relative bg-white rounded-xl border border-purple-200 p-3 flex flex-col justify-between min-h-[104px] overflow-hidden"
          >
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-purple-100" />
            <div className="flex items-start justify-between pt-0.5">
              <div className="space-y-1.5">
                <div className="h-2.5 w-16 bg-gray-200 rounded-sm" />
                <div className="h-6 w-12 bg-gray-300 rounded-sm" />
              </div>
              <div className="w-9 h-9 rounded-lg bg-purple-50" />
            </div>
            <div className="h-1 w-full bg-gray-100 rounded-full mt-2" />
          </div>
        ))}
      </div>
    </div>

    {/* CTAs de Conversão */}
    <div className="bg-white rounded-xl border border-purple-200 p-3 shadow-xs">
      <div className="flex items-start gap-3 border-b pb-2 border-purple-100 mb-3">
        <div className="w-10 h-10 bg-emerald-100 rounded-xl shrink-0" />
        <div className="h-10 flex flex-col justify-between">
          <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
          <div className="h-2.5 w-52 bg-gray-200 rounded-sm" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {[1, 2].map((i) => (
          <div key={i} className="p-3 border border-purple-200 rounded-xl">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="space-y-1.5 flex-1">
                <div className="h-2.5 w-20 bg-gray-100 rounded-sm" />
                <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
              </div>
              <div className="h-10 w-16 bg-emerald-50 rounded-lg shrink-0" />
            </div>
            <div className="h-1 w-full bg-gray-50 rounded-full mb-1.5" />
            <div className="flex justify-between">
              <div className="h-2 w-16 bg-gray-100 rounded-sm" />
              <div className="h-2 w-16 bg-gray-100 rounded-sm" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ContentRecommendationsSkeleton;
